import ChatSDK from 'test-iso-chat-sdk';

export const getTotalUnreadConversationsCount = async () => {
    const response = await ChatSDK.getInstance().Conversation.getConversationUnreadCount();
    return response?.count;
}


export const getUnreadConversations = async () => {
    const response = await ChatSDK.getInstance().Conversation.getUnreadConversations();
    return response.conversations;
}
